import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "z-50 absolute bg-white/90 w-screen h-screen flex items-center justify-center"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1)
const _hoisted_4 = { class: "mt-16 text-base font-semibold" }

import { onMounted } from "vue";
import { useDataStore } from "./stores/dataStore";
import { useSubjectStore } from "./stores/subjectStore";
import { useProductStore } from "./stores/productStore";
import { useSchoolStore } from "./stores/schoolStore";
import { toastContainers } from 'vue3-toastify'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const dataStore = useDataStore();
const subjectStore = useSubjectStore();
const productStore = useProductStore();
const schoolStore = useSchoolStore();

onMounted(async () => {
  await subjectStore.fetchSubjects();
  await productStore.fetchProducts();
  await schoolStore.fetchLocales();

  schoolStore.setLocale();

  console.log("App Mounted");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(dataStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(dataStore).loadingMessage), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(_unref(toastContainers))
  ], 64))
}
}

})